<template>
    <div >    
        <v-layout row wrap class="ma-"   >   
            <v-btn color="success">text</v-btn>
        </v-layout>
        <!-- //DIALOGS -->
        <div>
            <mbs-item-manager 
                :show="false"  
                :name_item="selected_field_action?selected_field_action.NAME_ITEM:null"   
                :field_items="selected_field_action?selected_field_action.fields:null"   
                :path_item="selected_field_action?selected_field_action.path:null"  
                :select_items="SELECT_ITEMS"   
            />   
        </div>
    </div> 
</template>

<script>
    import DATA from '../../plugins/DATA';
    let PAGE_NAME  = "INPUT_FIELDS" 
    
    export default {
        name:PAGE_NAME,
        props:[
            'show','value', 
            'field_items', 
            'select_items', 
            'disabled_fields',  
            'update_item',  
        ],
        data() {
            return { 
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
  
                excelSelecter:false,
                EXCEL_DATA_ITEMS:[],
                generatedCode:null, 
                inputCode:null, 
                inputCodeLoading:false, 
                menu_date_picker:{},
                menu_time_picker:{},
                dialog_time_picker:{},
                dialogInput:{},
                search:'',  
                search_input:null,   
                input:this.value,
                selected_field_action:null, 
                field_items2:null, 
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {   
                //SET AUTO CODE
                let input = this.input
                this.field_items2 = this.field_items   
                let items = this.field_items   
                if (items) {
                    items.forEach(field => {
                        //CODE
                        if (field.value == "code") {
                            if (field.auto_code) {
                                if (field.auto_code.onstart && !input.code) {
                                   this.setAutoCode(field.auto_code.values,false) 
                                }
                            }
                        }
                        //DATE
                        if (field.type == "date") {
                            if (field.onstart && !input[field.value]) {
                                let moment = this.MBS.date.moment
                                let today = this.MBS.date.today
                                let tomorrow = this.MBS.date.tomorrow
                                let yesterday = this.MBS.date.yesterday
                                if (field.onstart=="today") {
                                    this.input[field.value] = today
                                }else if (field.onstart=="tomorrow") {
                                    this.input[field.value] = tomorrow
                                }else if (field.onstart=="yesterday") {
                                    this.input[field.value] = yesterday
                                }else{
                                    this.input[field.value] = today
                                }    
                            }
                        } 
                    });
                }
                //
                let code = this.value.code?this.value.code:null
                let generatedCode = this.value.generatedCode?this.value.generatedCode:null
                if (code) {
                    this.inputCode = code
                }if (generatedCode) {
                    this.generatedCode = generatedCode
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            us(){
                return this.$store.getters.getUser
            },
            ud(){
                return this.$store.getters.getUserDetails
            },
            loading(){  
                return this.MBS.actions.loading
            },
            processes(){  
                return this.MBS.actions.processes
            }, 
            responses(){  
                return this.MBS.actions.responses
            }, 
            FIELD_ITEMS(){ 
                let items = null 
                if (this.field_items2) {
                    items = [...this.field_items2]
                }else{
                    items = [
                        {type:"number",name:"code",value:"code",label:"Code",required:true,sm:12,md:12}, 
                        {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:12},   
                    ]  
                } 
                return items
            }, 
            DisableField(){
                let disabled_fields = this.disabled_fields
                return field=>{
                    if(!field){return false}
                    if(!disabled_fields){return field.disabled?true:false}
                    let disabled = disabled_fields.indexOf(field.value)>-1?true:false
                    return disabled
                }
            },
            SELECT_ITEMS(){ 
                let item = this.select_items 
                return item?item:null
            }, 
            GET_SELECT_ITEMS(){  
                return item=>{
                    let select_item = this.SELECT_ITEMS
                    if(!select_item||!item){return null}
                    let name = item.select?item.select.name:null
                    let filter = item.select?item.select.filter:null
                    if(!name){return null}
                    if(!select_item[name]){return null}
                    if(filter){
                        let filter_name = filter.name
                        let filter_input = filter.input 
                        let input = this.input
                        let this_input = input?input[filter_input]:null
                        if(!this_input){return false}
                        return select_item[name].filter(item=>item[filter_input]==this_input)
                    } 
                    return select_item[name]
                } 
            },   
        },
        methods: {  
            FIELD_APPEND_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            path = DATA.PATHS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                            path = this.MBS.actions.COMPANY_LINK(path,element.company_link) 
                        if (element.append) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                path:path,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELD_NO_DATA_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            path = DATA.PATHS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                            path = this.MBS.actions.COMPANY_LINK(path,element.company_link) 
                        if (element.no_data) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                path:path,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELD_NO_DATA_SEARCH_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                        if ((element.searchable)) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELDS_ACTION(action){
                try {   
                    this.selected_field_action = action
                    // if (action.action=="add_item") {
                        setTimeout(() => { 
                            this.MBS.events.$emit("ITEM_ACTION",action.action,action)
                        }, 0);
                    // }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            AT_SEARCH_INPUT(input){
                try {  
                    this.search_input = input
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'AT_SEARCH_INPUT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            CREATE_FIELDS_ARRAY_DATA(child,input,notify){
                try { 
                    let code = this.inputCode
                    //CREATE ITEM ARRAY
                    let fields_array_data = {}
                    let required = false
                    let field_items = child?this.FIELD_CHILD_ITEMS:this.FIELD_ITEMS
                    if (input.key) {
                        fields_array_data["key"]=input.key
                    }
                    field_items.forEach(field => {
                        if (field.value==='code') {
                            fields_array_data.code = code 
                        } else {
                            let value = input[field.value]?input[field.value]:null
                            if (!value) {
                                if (field.required) {
                                    if (notify) {
                                        this.MBS.actions.dialog({
                                            show:true,
                                            fixed:false,
                                            title:this.MBS.text.field_required(field.label).title,
                                            text:this.MBS.text.field_required(field.label).text,
                                            btnYes:this.MBS.text.field_required(field.label).btnYes
                                        }) 
                                    }
                                    required = true
                                }
                            }else{
                                fields_array_data[field.value] = value 
                            }
                        } 
                    }); 
                    return {
                        fields_array_data:fields_array_data,
                        required:required
                    }
                         
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_FIELDS_ARRAY_DATA',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            async setAutoCode(values,notify=true){ 
                this.inputCodeLoading = true
                try {
                    if (this.generatedCode) {
                        this.inputCode = this.generatedCode
                        this.inputCodeLoading = false 
                    }else{
                        let res = await this.MBS.actions.CODE_GENERATE(
                            this.MBS.actions.TEXT_UP(values)) 
                        this.inputCode= res.code 
                        this.generatedCode= res.code 
                        this.input.generatedCode= res.code 
                        this.inputCodeLoading = false 
                    }
                    if (notify) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:this.MBS.text.generate_code_successful.title,
                            text:this.MBS.text.generate_code_successful.text,
                            btnYes:this.MBS.text.generate_code_successful.btnYes,
                        })   
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'setAutoCode',
                        page:PAGE_NAME, 
                    }) 
                    this.inputCodeLoading = false
                }
            },
            isAutoCode(code){ 
                try {
                    if(!this.generatedCode){return false}
                    if(!code){return false}
                    if (this.generatedCode === code) {
                        return true
                    } 
                } catch (error) {
                   this.MBS.actions.error({
                        error:error,
                        from:'isAutoCode',
                        page:PAGE_NAME, 
                    })  
                }
                return false
            }, 
            
            //---------------[MAIN FUNCTIONS]------------
            SAVE_DIALOG_TIME_PICKER(value){
                try {
                   this.input[value] = this.dialogInput[value] 
                   this.dialog_time_picker[value]= false
                   this.UPDATE_MODEL()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_MODEL(){
                try { 
                    this.search_input=null
                    this.$emit('input', {...this.input})
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {  
                        if (action.code ===PAGE_NAME+'=AUTO-GENERATE-CODE') { 
                            if (action.YES) {
                                this.EXCEL_DATA_ITEMS= this.MBS.actions.CODE_AUTO_GENERATE(this.EXCEL_DATA_ITEMS) 
                                setTimeout(() => { 
                                    this.MBS.actions.dialog({
                                        show:true,
                                        fixed:true,
                                        title:'GENERATED',
                                        text:"Code, successfully generated.",
                                        btnYes:"OK"
                                    }) 
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=AUTO-SET-CODE') { 
                            if (action.YES) {
                                this.inputCodeLoading = true
                                setTimeout(() => { 
                                    this.setAutoCode()
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else {
                                
                            }
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },
              
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        },
        watch: { 
            us(v){ 
            },  
            input(currentValue) {  
                this.$emit('input', {...currentValue})
            }, 
            inputCode(currentValue) { 
                this.input.code=currentValue
            },    
        },
  }
</script>